import React, { Component, Fragment } from "react";
import * as R from "ramda";
import axios from "axios";
import { formatAnswer } from "../../utils/formatAnswer";

/**
 * 交卷後的結果頁。
 *
 * 這裡原本是「在瀏覽器裡批改」：伺服器把整份考卷連同正確答案送到前端，
 * 前端逐題比對、換算成雅思分數，再把算好的分數回傳給伺服器儲存。
 * 那個做法有兩個問題——答案在瀏覽器裡看得到，分數也可以被竄改。
 *
 * 現在改成：前端只負責把學生的原始作答格式化成顯示文字後送出，
 * 由伺服器批改並回傳結果。前端拿到的 answerKey 只剩題號與題型的「殼」，
 * answer 欄位是空的（見後端 getExamByUrlKey），formatAnswer 只需要
 * 題型與題號，因此格式化仍然正常運作。
 */
class TestResult extends Component {
  state = {
    loading: true,
    result: null,
    errorContent: "",
  };

  componentDidMount() {
    let formatedAnswers;
    try {
      const questionIdSort = R.sortWith([R.ascend(R.prop("questionId"))]);
      const KEYS = questionIdSort(this.props.answerKey);
      const answers = questionIdSort(this.props.storedAnswers);

      formatedAnswers = KEYS.map((KEY) => {
        const questionId = KEY.questionId;
        const answer = R.find(R.propEq("questionId", questionId))(answers);
        const formatedAnswer = formatAnswer(this.props.testPages, KEY, answers);
        return answer === undefined
          ? { questionId, answer: formatedAnswer }
          : { ...answer, answer: formatedAnswer };
      });
    } catch (e) {
      this.setState({
        loading: false,
        errorContent: `${e.toString()}：${JSON.stringify(this.props.storedAnswers)}`,
      });
      return;
    }

    const url =
      process.env.REACT_APP_UPDATE_EXAMDETAIL +
      "/" +
      this.props.candidate.examDetailId;

    axios
      .post(url, { stored_answers: JSON.stringify(formatedAnswers) })
      .then((res) => {
        const data = res.data;
        if (data && data.success && data.result) {
          this.setState({ loading: false, result: data.result });
        } else {
          // 作答已經存進資料庫了，只是結果算不出來（例如題目資料異常）。
          // 這裡不能讓學生以為交卷失敗而重考。
          this.setState({
            loading: false,
            errorContent:
              "Your answers have been submitted successfully, " +
              "but the result could not be displayed. Please contact the administrator.",
          });
        }
      })
      .catch((e) => {
        this.setState({
          loading: false,
          errorContent: `${e.toString()}：${JSON.stringify(this.props.storedAnswers)}`,
        });
      });
  }

  renderResultContent(status, id, answer) {
    return (
      <li className={status} key={id}>
        {id}. <span>{answer}</span>
      </li>
    );
  }

  render() {
    const { loading, result, errorContent } = this.state;

    return (
      <div className="test-result-container">
        {errorContent && (
          <Fragment>
            <p style={{ color: "red !important" }}>
              Error! Sorry but something goes wrong.
            </p>
            <p style={{ color: "red !important" }}>
              Copy the following text to website owner.
            </p>
            <p>{errorContent}</p>
          </Fragment>
        )}

        <h1>Test Result</h1>

        {loading && <h3>Submitting your answers…</h3>}

        {result && (
          <Fragment>
            <h3>
              <div>
                <b>{result.score}</b>: {result.level}
              </div>
            </h3>
            <ul>
              {result.questions.map((q) =>
                this.renderResultContent(
                  q.status,
                  String(q.seq).padStart(2, "0"),
                  q.answer
                )
              )}
            </ul>
          </Fragment>
        )}
      </div>
    );
  }
}

export default TestResult;
